// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"8037249a","709":"6b3466c0","919":"754abc84"}[chunkId] + ".chunk.js";
};